__webpack_require__.p = "https://oreillymedia.github.io/wc-orm-chat/";